import type { ApiSuccessEnvelope } from "../../types/affiliates";

export const STAFF_REGULATOR_STATUSES = ["pending", "approved"] as const;

export type StaffRegulatorStatus = (typeof STAFF_REGULATOR_STATUSES)[number];

export type StaffRegulator = {
  admin_id: string;
  email: string;
  status: StaffRegulatorStatus;
  given_name: string | null;
  family_name: string | null;
  timezone: string | null;
  whitelisted_ips: string[];
};

export type StaffRegulatorsListData = {
  items: StaffRegulator[];
};

export type CreateStaffRegulatorRequest = {
  email: string;
  given_name: string;
  family_name: string;
  timezone: string;
  whitelisted_ips: string[];
};

export type StaffRegulatorEnvelope<T> = ApiSuccessEnvelope<T>;
